module.exports = __webpack_public_path__ + "img/21.da371ce1.jpg";